import { render } from "./App.vue?vue&type=template&id=27ef0531"
const script = {}

import exportComponent from "/Users/cschultz/Code/iib/wp-content/plugins/ibj-people/people/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__